import React, {useState} from "react";
import { ReactComponent as MultiQIcon } from "../../Icons/MultiQIcon.svg";
import { ReactComponent as UploadIcon } from "../../Icons/upload.svg";
import { Modal } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { toast } from "react-toastify";
import { rfpUpload } from "../../API/api";
import styles from "../../Component/Modals/RFPUploadModal/AskTheTeamStyles.module.css";
import SelectComp from "../../NewComponent/Select/Select";
import MultiSelect from "../../NewComponent/MultiSelect/MultiSelect";

const submitSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
export default function Form() {
    const [isImgShow, setShow] = useState(false);
    const userState = useSelector((state) => state.user);
    const [islanguage, setIsLanguage] = useState("English");
    const [selected, setSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedDomains, setSelectedDomains] = useState([]);
    const [selectedDocType, setSelectedDocType] = useState('All');
    const [type, setType] = useState("Detailed");
    const modalState = useSelector((state) => state.domain);
    const dispatch = useDispatch();
    const { advanceFilterModalToggle } = bindActionCreators(Actions, dispatch);
    const onChangeFile = (e) => {
        setSelected([]);
        setSelected([e.target.files[0]]);
      };
  const continaerStyles = {
    border: "1px dashed #ACB6C6",
    background: "#FFFFFF",
    // padding:'20px 32px 1px 32px',
    // height: "325px",
    borderRadius: "14px",
  };
  const first = {
    height: "241px",
    // border: '1px dotted #ACB6C6',
    borderStartEndRadius: "14px",
    borderStartStartRadius: "14px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const second = {
    // minHeight: "82px",
    // border: '1px solid #F6F7F8',
    borderEndEndRadius: "14px",
    borderEndStartRadius: "14px",
    background: "#F6F7F8",
    padding:'20px'
  };
  const textContainer = {
    padding: "20px",
    textAlign: "center",
    // width:'80%'
  };
  const texts = {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#5C667B",
  };
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
    // color:'red'
  });
  const textsColor = {
    fontSize: "16px",
    lineHeight: "24px",
    cursor:'pointer',
    textDecoration:'underline',
    background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    " -o-text-fill-color": "transparent",
  };
  const updatesDomains = (arr) => {
    arr.filter(ar=>{
      ar.label = ar.name;
      ar.value = ar.indexId;
      return ar;
    })
    return arr;
  };
  const onClickSubmit = () => {
    if (selected.length === 0) {
        toast.warning(submitSuccessToast('Please choose file!'), {
            position: toast.POSITION.TOP_RIGHT,
          });
        return ;
    }
    let obj = {
      language: islanguage,
      type: type,
      domainIds:
        selectedDomains.length === 0
          ? ""
          : selectedDomains.sort().toString(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      source:selectedDocType==='All'?undefined:selectedDocType
    };
    let fd = new FormData();
    fd.append("file", selected[0]);
    fd.append("metadata", JSON.stringify(obj));
    rfpUpload(fd).then((res) => {
      if (res===undefined) return;
    //   advanceFilterModalToggle({ bool: false, value: "" });
      if (res.data.success) {
        setSelected([]);
        setSelectedDomains([]);
        setIsLanguage('English');
        setSelectedDocType('All');
        setType('Detailed');
        toast.success(submitSuccessToast(res.data.message), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    });
  };

  const elemInDesiredArr = (arr)=>{
    let newArr = [];
    arr.filter(asd=>{
        newArr.push({name:asd,value:asd,label:asd});
    })
    return newArr;
  }
  const onChangeLanguage = (lang) => {
    setIsLanguage(lang);
  };
  const onChangeType = (type) => {
    setType(type);
  };

  const onChangeDomain = (domain) => {
    setSelectedDomains(domain);
  };
  const onChangeDocType= (docType) => {
    setSelectedDocType(docType);
  };
  return (
    <div style={continaerStyles}>
      <div style={first}>
        <div style={textContainer}>
          <div style={{ marginBottom: "5px" }}>
            <MultiQIcon />
          </div>
          <div style={texts}>
            Upload a file with up to 20 questions and we will provide back the
            file with all answers and a summary.
          </div>
          <div style={texts}>
            Please provide file in .xls format. Example <span style={textsColor} onClick={()=>setShow(true)}>Here</span>&nbsp;
            {/* <img style={{cursor:'pointer',border:'1px solid #f2f2f2'}} width={'50px'} height={'30px'} src={require('../../Images/rfp2.png')}/> */}
          </div>
          <div className="mt-2">
          <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  style={{
                   padding:'14px 24px 14px 24px',
                    textTransform: "none",
                    border: '1px solid #F6F7F8',
                    height:'42px',
                    // width:'160px',
                    background: '#FFFFFF',
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    fontSize:'16px',
                    lineHeight:'24px',
                    color:'#2A364A',
                    // fontWeight:"00",
                    borderRadius:'8px'
                  }}
                  // startIcon={}
                >
                  <UploadIcon/>
                  &nbsp;Upload File
                  <VisuallyHiddenInput
                    type="file"
                    accept={".xls, .xlsx"}
                    onChange={(e) => onChangeFile(e)}
                  />
                </Button>
          </div>
        </div>
      </div>
      <div style={second}>
      <div
             
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div style={{ display: "flex", flexWrap:'wrap', alignItems:'center' }}>
                <div>
                    <SelectComp isString={false} val={islanguage} onChangeFunc={onChangeLanguage} width={'120px'} options={elemInDesiredArr(userState.multipleLanguages)}/>
                </div>
                &nbsp;
                <div>
                <SelectComp isString={false} val={type} onChangeFunc={onChangeType} width={'120px'} options={[{label:'Detailed', value:'Detailed'},{label:'Short', value:'Summary'}]}/>
                </div>
                &nbsp;
                <div >
                  <MultiSelect
                    value={selectedDomains}
                    options={updatesDomains(userState.expertTopics)}
                    onChangeFunc={onChangeDomain}
                    placeholder={'Select Domains'}
                  />
                </div>
                &nbsp;
                <div >
                  <SelectComp
                    val={selectedDocType}
                    onChangeFunc={onChangeDocType}
                    width={'120px'}
                    isString={false}
                    options={[{label:'All',value:'All',name:'All'},{label:'Expert QA',value:'Expert QA',name:'Expert QA'},{label:'Pdf',value:'Pdf',name:'Pdf'},{label:'Video',value:'Video',name:'Video'},{label:'Image',value:'Image',name:'Image'},{label:'Url',value:'Url',name:'Url'},{label:'Thread',value:'Thread',name:'Thread'}]}
                  />
                </div>
              </div>
              <div style={{  float: "right" }}>
                <button
                className='buttonPrimary'
                  onClick={onClickSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
      </div>
      <div>
        <Modal
          show={isImgShow}
          onHide={() => setShow(false)}
          centered={true}
          size="lg"
        >
          <Modal.Body style={{ textAlign: "center" }}>
            <img
              style={{ width: "100%" }}
              src={require('../../Images/rfp2.png')}
            />
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
